import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

import { FoundationRoute } from '../../../constants';

@Controller({ fragment: 'inactivity', component: 'main-layout' })
export default class InactivityController {

  @OnClick({ target: 'button-return-login' })
  onGoToLoginButtonClick(): void {
    HistoryService.push(FoundationRoute.LOGIN);
  }
}
